<main class="!mx-auto !w-full !max-w-3xl !pb-28 !text-strong sm:!pb-12">
    <a [routerLink]="backRoute"
       class="!mb-5 !inline-flex !min-h-[40px] !items-center !gap-2 !text-sm !font-medium !text-slate-600 hover:!text-primary">
        <i class="bi bi-arrow-left" aria-hidden="true"></i> Torna al profilo atleta
    </a>

    <div *ngIf="loading" class="!flex !animate-pulse !flex-col !gap-4" role="status" aria-label="Caricamento tesseramento">
        <div class="!h-8 !w-56 !max-w-full !rounded !bg-slate-200"></div>
        <div class="!h-72 !rounded-2xl !border !border-solid !border-slate-200 !bg-white"></div>
        <div class="!h-40 !rounded-2xl !border !border-solid !border-slate-200 !bg-white"></div>
    </div>

    <ng-container *ngIf="!loading">
        <header class="!mb-6 !flex !flex-col !gap-3 sm:!flex-row sm:!items-end sm:!justify-between">
            <div class="!min-w-0">
                <h1 class="!m-0 !text-2xl !font-bold !tracking-tight !text-strong sm:!text-3xl">Tesseramento</h1>
                <p class="!mb-0 !mt-2 !text-sm !leading-6 !text-slate-600">
                    Dati del tesserino federale di <span class="!font-semibold !text-strong">{{ athlete.firstName }} {{ athlete.lastName }}</span>.
                </p>
            </div>
            <div class="!flex !flex-wrap !gap-2">
                <span class="!inline-flex !items-center !gap-1.5 !rounded-md !px-2 !py-1 !text-xs !font-semibold"
                      [ngClass]="isRegistered ? '!bg-emerald-50 !text-emerald-700' : '!bg-slate-100 !text-slate-600'">
                    <i class="bi" [ngClass]="isRegistered ? 'bi-check-circle' : 'bi-circle'" aria-hidden="true"></i>
                    {{ isRegistered ? 'Tesserato' : 'Non tesserato' }}
                </span>
                <span class="!inline-flex !items-center !gap-1.5 !rounded-md !px-2 !py-1 !text-xs !font-semibold"
                      [ngClass]="isSigned ? '!bg-emerald-50 !text-emerald-700' : '!bg-amber-50 !text-amber-800'">
                    <i class="bi" [ngClass]="isSigned ? 'bi-pen' : 'bi-hourglass-split'" aria-hidden="true"></i>
                    {{ isSigned ? 'Firmato' : 'Firma mancante' }}
                </span>
            </div>
        </header>

        <form class="!flex !flex-col !gap-4" novalidate (ngSubmit)="sendMembership()">
            <!-- Dati tesserino -->
            <section class="!rounded-2xl !border !border-solid !border-slate-200 !bg-white !p-5 sm:!p-6" aria-labelledby="badge-title">
                <h2 id="badge-title" class="!mb-4 !mt-0 !text-base !font-bold !text-strong">Dati del tesserino</h2>
                <div class="!grid !grid-cols-1 !gap-5 md:!grid-cols-2">
                    <div class="!min-w-0">
                        <label for="badge-details" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Numero tesserino</label>
                        <input id="badge-details" data-field="badgeDetails" type="text" name="badge-details"
                               class="form-control !min-h-11 !rounded-xl !border-slate-200 !font-mono !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                               autocomplete="off" spellcheck="false" maxlength="60" placeholder="Es. 123456789"
                               [(ngModel)]="membership.badgeDetails" [readonly]="isAthleteUser" [class.is-invalid]="showError('badgeDetails')"
                               (blur)="normalize('badgeDetails'); markTouched('badgeDetails')">
                        <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('badgeDetails') as error">{{ error }}</p>
                    </div>

                    <div class="!min-w-0">
                        <label for="badge-expiration" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Scadenza</label>
                        <input id="badge-expiration" data-field="badgeExpiration" type="date" name="badge-expiration"
                               class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                               [(ngModel)]="membership.badgeExpiration" [readonly]="isAthleteUser" [class.is-invalid]="showError('badgeExpiration')"
                               (blur)="markTouched('badgeExpiration')">
                        <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('badgeExpiration') as error">{{ error }}</p>
                        <span *ngIf="expirationStatus as expiration"
                              class="!mt-1.5 !inline-flex !items-center !gap-1.5 !rounded-md !px-2 !py-0.5 !text-xs !font-semibold" [ngClass]="expiration.classes">
                            <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>{{ expiration.text }}
                        </span>
                    </div>

                    <div class="!min-w-0">
                        <label for="federation-name" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Federazione</label>
                        <input id="federation-name" data-field="federationName" type="text" name="federation-name"
                               class="form-control !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary focus:!shadow-[0_0_0_4px_rgba(var(--primary-rgb),0.12)]"
                               autocomplete="off" maxlength="120" placeholder="Es. FIGC, FIP, FIPAV"
                               [(ngModel)]="membership.federationName" [readonly]="isAthleteUser" [class.is-invalid]="showError('federationName')"
                               (blur)="normalize('federationName'); markTouched('federationName')">
                        <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('federationName') as error">{{ error }}</p>
                    </div>

                    <div class="!min-w-0">
                        <label for="athlete-category" class="form-label required !mb-1.5 !text-sm !font-semibold !text-slate-600">Categoria</label>
                        <select id="athlete-category" data-field="categoryId" name="athlete-category"
                                class="form-select !min-h-11 !rounded-xl !border-slate-200 !text-base focus:!border-primary"
                                [(ngModel)]="membership.categoryId" [disabled]="isAthleteUser" [class.is-invalid]="showError('categoryId')"
                                (blur)="markTouched('categoryId')">
                            <option value="">Seleziona una categoria</option>
                            <option *ngFor="let category of categories" [value]="category.id">{{ category.name }}</option>
                        </select>
                        <p class="!mb-0 !mt-1.5 !text-sm !text-red-600" *ngIf="showError('categoryId') as error">{{ error }}</p>
                        <p *ngIf="!categories.length" class="!mb-0 !mt-1.5 !text-xs !text-slate-500">Nessuna categoria disponibile per la stagione corrente.</p>
                    </div>
                </div>
            </section>

            <!-- Stato -->
            <section class="!rounded-2xl !border !border-solid !border-slate-200 !bg-white !p-5 sm:!p-6" aria-labelledby="status-title">
                <h2 id="status-title" class="!mb-4 !mt-0 !text-base !font-bold !text-strong">Stato del tesseramento</h2>
                <div class="!flex !flex-col !divide-y !divide-slate-100">
                    <label for="athlete-badged" class="!m-0 !flex !cursor-pointer !items-center !justify-between !gap-4 !pb-4">
                        <span class="!min-w-0">
                            <span class="!block !text-sm !font-semibold !text-strong">Atleta tesserato</span>
                            <span class="!block !text-xs !leading-5 !text-slate-500">Il tesserino è stato emesso dalla federazione.</span>
                        </span>
                        <span class="form-check form-switch !m-0 !shrink-0 !p-0">
                            <input id="athlete-badged" type="checkbox" role="switch" name="registered"
                                   class="form-check-input !m-0 !cursor-pointer"
                                   [(ngModel)]="isRegistered" [disabled]="isAthleteUser">
                        </span>
                    </label>

                    <div class="!flex !flex-col !gap-3 !pt-4">
                        <label for="athlete-badge-sign" class="!m-0 !flex !cursor-pointer !items-center !justify-between !gap-4">
                            <span class="!min-w-0">
                                <span class="!block !text-sm !font-semibold !text-strong">Tesseramento firmato</span>
                                <span class="!block !text-xs !leading-5 !text-slate-500">L'atleta (o il genitore) ha firmato il modulo di tesseramento.</span>
                            </span>
                            <span class="form-check form-switch !m-0 !shrink-0 !p-0">
                                <input id="athlete-badge-sign" type="checkbox" role="switch" name="signed"
                                       class="form-check-input !m-0 !cursor-pointer"
                                       [(ngModel)]="isSigned" [disabled]="isAthleteUser">
                            </span>
                        </label>
                        <div *ngIf="!isSigned && !isAthleteUser" class="!flex !flex-col !gap-2 !rounded-xl !bg-slate-50 !p-3 sm:!flex-row sm:!items-center sm:!justify-between">
                            <p class="!m-0 !text-sm !leading-5 !text-slate-600">Ricorda all'atleta di firmare con una notifica email.</p>
                            <button type="button"
                                    class="btn welldone-btn-light !inline-flex !min-h-[40px] !shrink-0 !items-center !justify-center !gap-2 !px-3 !py-2 !text-sm"
                                    [disabled]="sendingNotification" (click)="sendMembershipNotification()">
                                <span *ngIf="sendingNotification" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <i *ngIf="!sendingNotification" class="bi bi-envelope" aria-hidden="true"></i>
                                Invia notifica
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Azioni: barra fissa su telefono -->
            <div *ngIf="!isAthleteUser" class="!fixed !inset-x-0 !bottom-0 !z-[1000] !flex !gap-3 !border-0 !border-t !border-solid !border-slate-200 !bg-white/95 !px-4 !py-3 !backdrop-blur sm:!static sm:!justify-end sm:!border-0 sm:!bg-transparent sm:!p-0 sm:!pt-2">
                <a [routerLink]="backRoute" class="btn welldone-btn-gray !inline-flex !min-h-[44px] !flex-1 !items-center !justify-center sm:!flex-none">Annulla</a>
                <button type="submit" class="btn btn-primary !inline-flex !min-h-[44px] !flex-[2] !items-center !justify-center !gap-2 sm:!flex-none"
                        [disabled]="saving">
                    <span *ngIf="saving" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    {{ hasMembership ? 'Salva modifiche' : 'Salva tesseramento' }}
                </button>
            </div>
        </form>
    </ng-container>
</main>
